// LobbyContent.js
import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { socket, camelCase } from "../../../helpers/global_helper";


const NumberResult = (props) => {

    const roomColorNumber = {
        '48D': {
            'black': [2, 4, 5, 7, 10, 12, 13, 15, 18, 20, 21, 23, 25, 27, 30, 32, 33, 35, 38, 40, 41, 43, 46, 48],
            'red': [1, 3, 6, 8, 9, 11, 14, 16, 17, 19, 22, 24, 26, 28, 29, 31, 34, 36, 37, 39, 42, 44, 45, 47],
            "green": [0]
        },

        '48D -NEW': {
            'black': [2, 4, 5, 7, 10, 12, 13, 15, 18, 20, 21, 23, 25, 27, 30, 32, 33, 35, 38, 40, 41, 43, 46, 48],
            'red': [1, 3, 6, 8, 9, 11, 14, 16, 17, 19, 22, 24, 26, 28, 29, 31, 34, 36, 37, 39, 42, 44, 45, 47],
            "green": [0]
        },
        '12D -NEW': {
            'black': [3, 4, 5, 7, 10, 12],
            'red': [1, 2, 6, 8, 9, 11],
            "green": [0]
        },
        '24D -NEW': {
            'black': [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24],
            'red': [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23],
            "green": [0]
        },
        '36D -NEW': {
            'black': [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35],
            'red': [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36],
            "green": [0]
        },
        '36D': {
            'black': [2, 6, 4, 8, 10, 11, 13, 15, 17, 20, 22, 24, 26, 28, 29, 31, 33, 35],
            'red': [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23, 25, 27, 30, 32, 34, 36],
            "green": [0]

        },
        '24D': {
            'black': [2, 4, 6, 8, 10, 11, 13, 15, 17, 20, 22, 24],
            'red': [1, 3, 5, 7, 9, 12, 14, 16, 18, 19, 21, 23],
            "green": [0]

        },
        '12D': {
            'black': [3, 4, 5, 7, 10, 12],
            'red': [1, 2, 6, 8, 9, 11],
            "green": [0]
        }
    };
    const [result, setResult] = useState([]);
    const [resultNumber, setResultNumber] = useState([]);

    useEffect(() => {
        const handleGameHistory = (result) => {
            if (result.room_id == props.room_id) {
            }
            if (result.room_id == props.room_id) {
                if (result.status != 'success') {
                    return;
                }
                let temp = [];
                let tempResultNumber = [];
                for (let key in result.results) {
                    if (['middle', 'edge', 'numbers'].includes(key))
                        continue;
                    temp.push({ key: camelCase(key), value: result.results[key] });
                }
                for (let key in result.results.numbers) {
                    tempResultNumber.push(result.results.numbers[key].value);
                }

                setResultNumber([...tempResultNumber]);
                setResult([...temp]);
            }
        };

        socket.on("game_history", handleGameHistory);

        // Cleanup on unmount
        return () => {
            socket.off("game_history", handleGameHistory);
        };
    }, [props.room_id, props.game_code, resultNumber, result]);



    useEffect(() => {
        socket.emit("game_history", { room_id: props.room_id });
    }, [props.room_id]);


    return (
        <>
            <div className="game_item_detail game_ding_dong">

                <ul>
                    {result.length > 0 && result.map((obj, index) => {
                        if ((props.game_code === "12D" || props.game_code === "24D" || props.game_code === "36D" || props.game_code === "36D -NEW" || props.game_code === "12D -NEW" || props.game_code === "24D -NEW") && obj.key === "Medium") {
                            return null;
                        }
                        return (
                            <li key={index}>
                                <span>{props.t((obj.key).toLowerCase())}</span>:
                                <span className="game_ding_dong_blue">{parseInt(obj.value)}%</span>
                            </li>
                        );
                    })}
                </ul>
                <div className="game_ding_dong_points">
                    <div className="game_ding_dong_current" style={{ background: (roomColorNumber[props.game_code]['green'].includes(resultNumber[0]) ? "#006400" : roomColorNumber[props.game_code]['black'].includes(resultNumber[0]) ? 'black' : 'red') }}>{resultNumber.length > 0 ? resultNumber[0] : ''}</div>
                    <ul className="ding_dong_points_list">
                        {resultNumber.map((value, index) => {
                            return (
                                <React.Fragment key={index}>
                                    {
                                        index !== 0 ? (
                                            <li className={
                                                roomColorNumber[props.game_code] && roomColorNumber[props.game_code]['green'] && roomColorNumber[props.game_code]['green'].includes(value)
                                                    ? "green"
                                                    : (roomColorNumber[props.game_code] && roomColorNumber[props.game_code]['black'] && roomColorNumber[props.game_code]['black'].includes(value))
                                                        ? 'black'
                                                        : 'red'
                                            }>
                                                {value}
                                            </li>
                                        ) : ''}

                                </React.Fragment>

                            )
                        })}
                    </ul>
                </div>
            </div >
        </>
    );
}

export default withTranslation()(NumberResult);
